import React, { FC, useState } from "react";
import "./HoverInfo.css"

interface IProps {
    children:any,
    info?:any
};

const HoverInfo:FC<IProps> = ({children, info}) => {
    const [isHovering, setIsHovering] = useState(false)
    const newUI = localStorage.getItem("newUI")?.toLowerCase() === 'true';
    return <div
        style={{position:'relative'}}>
        <div onMouseEnter={()=>setIsHovering(true)} onMouseLeave={()=>setIsHovering(false)}>
            {children}
        </div>
        {isHovering ? 
        <div 
        className="speech-bubble-right"
        style={{
            zIndex:'10',
            position: 'absolute',
            background: newUI? '#001F47':'#ffffff57',
            color: '#ffffff',
            fontSize: '0.8rem',            
            textAlign: 'center',
            borderRadius: '5px',
            padding: '10px',
            border: '#ffffff57 solid 1px',
            bottom:'100%',
            right: '-50%',
            width: '10rem'
    
        }}
        >{info}</div> 
        : null}
    </div>

};

export default HoverInfo;